module.exports = __webpack_public_path__ + "img/libohu.222d56dd.png";